import script from "./ImportFrame.vue?vue&type=script&setup=true&lang=ts"
export * from "./ImportFrame.vue?vue&type=script&setup=true&lang=ts"

import "./ImportFrame.vue?vue&type=style&index=0&id=1f8f1e50&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f8f1e50"]])

export default __exports__